export const webhookSelectors = {
  gridData: (state) => state.gridData,
  item: (state) => state.item,
  stat: (state) => state.stat,
  update: (state) => state.update,
}
